"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Radio = _styledComponents["default"].label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 0;\n    position: relative;\n    font-size: 0.875rem !important;\n    cursor: pointer;\n    font-weight: 300 !important;\n\n    &:hover {\n        .radio {\n            border-color: ", ";\n        }\n    }\n\n    input {\n        width: auto;\n        margin-right: 15px;\n        opacity: 0;\n        visibility: hidden;\n        height: 30px;\n    }\n\n    .radio {\n        position: absolute;\n        top: calc(50% - 10px);\n        left: 0;\n\n        display: inline-block;\n        height: 19px;\n        width: 19px;\n        border-radius: 50%;\n        border: 1px solid ", ";\n        transition: border 0.2s linear;\n    }\n\n    input:checked + .radio {\n        &:before {\n            content: '';\n            display: block;\n            height: 11px;\n            width: 11px;\n            border-radius: 50%;\n            position: absolute;\n            top: 3px;\n            left: 3px;\n            background-color: ", ";\n        }\n    }\n"])), function (props) {
  return props.theme.admin.colors.brand;
}, function (props) {
  return props.theme.admin.font.color;
}, function (props) {
  return props.theme.admin.colors.brand;
});

exports.Radio = Radio;